import { useApi } from "../lib/api";
import { Seo } from "../components/Seo";
import { CoverBanner } from "../components/home/CoverBanner";
import { Marquee } from "../components/Marquee";
import { LeadGrid } from "../components/home/LeadGrid";
import { FeatureSpread } from "../components/home/FeatureSpread";
import { CategoryRail } from "../components/home/CategoryRail";
import { MostRead } from "../components/home/MostRead";
import { Newsletter } from "../components/home/Newsletter";
import { FromTheWeb } from "../components/home/FromTheWeb";
import { IssueDownload } from "../components/home/IssueDownload";
import { RiotBanner } from "../components/home/RiotBanner";
import { QuotePage } from "../components/home/QuotePage";

export default function Home() {
  const { data, isError } = useApi("/home");
  if (isError) {
    return <div className="min-h-screen grid place-items-center display text-5xl" data-testid="home-error">The press is down. Try again soon.</div>;
  }
  const top = data?.top ?? [];
  const latest = data?.latest ?? [];
  const s = data?.sections ?? {};
  return (
    <main data-testid="home-page">
      <Seo
        title="YOUTH — Youth Culture Magazine: Fashion, Art, Beauty"
        description="YOUTH is an online youth culture magazine: fashion, culture, art, beauty and RIOT stories, editorial photography and a free printable issue."
        path="/"
      />
      <CoverBanner cover={data?.cover} />
      <Marquee items={top} />
      <LeadGrid lead={top[0]} pair={top.slice(1, 3)} edit={[...top.slice(3), ...latest.slice(0, 3)]} />
      {data && <RiotBanner a={data.riot} />}
      <CategoryRail cat="fashion" items={s.fashion ?? []} index={1} tone="blush" />
      <FeatureSpread a={latest[3] ?? top[0]} />
      <CategoryRail cat="culture" items={s.culture ?? []} index={2} tone="cream" />
      <QuotePage q={data?.quote} />
      <MostRead items={data?.most_read ?? []} />
      <IssueDownload />
      <CategoryRail cat="art" items={s.art ?? []} index={3} tone="blush" />
      <CategoryRail cat="beauty" items={s.beauty ?? []} index={4} tone="cream" />
      <FromTheWeb />
      <Newsletter />
    </main>
  );
}
